<div class="source-field-mapping d-flex flex-column h-100">
  <ziro-loading-block [hidden]="!isLoading"></ziro-loading-block>

  @if (!isLoading) {
    <div class="ziro-card p-4 mb-4">
      <h4 class="fw-bold mb-1">
        {{ 'tkey;migrations.cisco.site_management.source_field_mapping.source_field.title' | translate }}
      </h4>
      <p class="text-muted mb-3">
        {{ 'tkey;migrations.cisco.site_management.source_field_mapping.source_field.subtitle' | translate }}
      </p>

      <div class="row g-3" data-automation="source-field-mapping-source-field-cards">
        @for (card of sourceFieldCards; track card.value) {
          <div class="col-md-3">
            <div
              class="source-field-card h-100 gap-2"
              [class.source-field-card--selected]="pendingSourceField === card.value"
              [attr.data-automation]="'source-field-mapping-card-' + card.value"
              (click)="onSourceFieldCardSelected(card.value)"
            >
              <div class="d-flex justify-content-between align-items-start">
                <div class="form-check d-flex flex-column p-0 m-0">
                  <label class="form-check-label fw-bold" [for]="'source-field-card-' + card.value">
                    {{ card.labelKey | translate }}
                  </label>
                  <p class="text-muted small mb-0">{{ card.descriptionKey | translate }}</p>
                </div>
                <input
                  type="radio"
                  class="form-check-input flex-shrink-0 ms-2"
                  [id]="'source-field-card-' + card.value"
                  name="sourceField"
                  [checked]="pendingSourceField === card.value"
                  [disabled]="isSavingSourceField"
                  (change)="onSourceFieldCardSelected(card.value)"
                />
              </div>
              <span class="badge rounded-pill bg-warning-subtle text-warning-emphasis align-self-start">
                {{
                  'tkey;migrations.cisco.site_management.source_field_mapping.source_field.values_discovered'
                    | translate: { count: card.discoveredCount }
                }}
              </span>
            </div>
          </div>
        }
      </div>

      <div class="d-flex justify-content-end mt-3">
        <ziro-button
          [buttonStyle]="buttonStyles.PRIMARY"
          [buttonSize]="buttonSizes.SMALL"
          [icon]="icons.SAVE_SUCCESS"
          [label]="'tkey;migrations.cisco.site_management.source_field_mapping.save_source_field' | translate"
          [isPending]="isSavingSourceField"
          [isDisabled]="isSavingSourceField || !pendingSourceField || pendingSourceField === persistedSourceField"
          [dataAutomation]="'source-field-mapping-save-source-field-button'"
          (clicked)="onSaveSourceField()"
        ></ziro-button>
      </div>
    </div>

    @if (!pendingSourceField) {
      <div class="ziro-card p-4 text-center text-muted" data-automation="source-field-mapping-empty-state">
        {{ 'tkey;migrations.cisco.site_management.source_field_mapping.empty_state.message' | translate }}
      </div>
    } @else {
      <div class="ziro-card p-4 flex-fill d-flex flex-column" data-automation="source-field-mapping-value-mappings">
        <div class="d-flex justify-content-between align-items-center mb-3">
          <div>
            <h4 class="fw-bold mb-1">
              {{ 'tkey;migrations.cisco.site_management.source_field_mapping.value_mappings.title' | translate }}
            </h4>
            <p class="text-muted mb-0">
              {{ 'tkey;migrations.cisco.site_management.source_field_mapping.value_mappings.subtitle' | translate }}
            </p>
          </div>
          <div class="d-flex align-items-center gap-2">
            <ziro-button
              [type]="buttonTypes.LINK"
              [buttonStyle]="buttonStyles.OUTLINE_DEFAULT"
              [buttonSize]="buttonSizes.SMALL"
              [icon]="icons.DOWNLOAD_SMALL"
              [label]="'tkey;migrations.cisco.site_management.source_field_mapping.download_template' | translate"
              [href]="templateUrl"
              [downloadFileName]="'value_mappings_template.csv'"
              [isDisabled]="isSavingMappings"
              [dataAutomation]="'source-field-mapping-download-template'"
            ></ziro-button>
            <ziro-button
              [label]="'tkey;migrations.cisco.site_management.source_field_mapping.import' | translate"
              [buttonStyle]="buttonStyles.OUTLINE_DEFAULT"
              [icon]="icons.IMPORT"
              [buttonSize]="buttonSizes.SMALL"
              [isDisabled]="isSavingMappings || isPreviewingUnsavedField"
              [tooltip]="importDisabledTooltipKey"
              [isTooltipDisabled]="!importDisabledTooltipKey"
              [dataAutomation]="'source-field-mapping-import-button'"
              (clicked)="importInput.click()"
            ></ziro-button>
            <input
              #importInput
              type="file"
              accept=".csv"
              class="d-none"
              data-automation="source-field-mapping-import-input"
              (change)="onImportFileSelected($event)"
            />
          </div>
        </div>

        @if (isPreviewingUnsavedField) {
          <div class="alert alert-warning" data-automation="source-field-mapping-preview-hint">
            {{ 'tkey;migrations.cisco.site_management.source_field_mapping.preview_unsaved_field.message' | translate }}
          </div>
        }

        <fieldset
          class="source-field-mapping-fieldset flex-fill"
          [disabled]="isSavingMappings || isPreviewingUnsavedField"
          data-automation="source-field-mapping-data-table"
        >
          <ziro-datatable
            [class]="'source-field-mapping-table'"
            [dataAutomation]="'source-field-mapping-data-table'"
            [uniqueRowIdentifier]="'rowId'"
            [columns]="columns"
            [rowDataSource]="rows"
            [mainFilterPlaceholder]="
              'tkey;migrations.cisco.site_management.source_field_mapping.table.filter.placeholder' | translate
            "
            [noResultsAlert]="'tkey;migrations.cisco.site_management.source_field_mapping.no_results.message'"
            [matchesSecondaryDataFn]="matchesSiteNameFilter"
            (rowFieldChanged)="onRowFieldChange($event)"
          ></ziro-datatable>
        </fieldset>
      </div>
    }
  }
</div>
